// extracted by mini-css-extract-plugin
export default {"table":"vehicles_list-module__d9LaF"};